import './styles.scss'

import { ChevronRightIcon } from '@/components/Icons'

function ServiceItem({
  name,
  onClick,
  path = '/request-services',
  serviceEntry,
}) {
  const handleItemClick = () => {
    onClick(serviceEntry, path)
  }

  return (
    <button
      className="service-item__wrapper"
      type="button"
      onClick={handleItemClick}
    >
      <div className="service-item">
        <span>{name}</span>
        <ChevronRightIcon />
      </div>
    </button>
  )
}

export default ServiceItem
